module.exports = __webpack_public_path__ + "media/images/front/common/linkArw-fa0923706fd83a88bdd987728a97658c.svg";